interface SettingsOptions {
    clientKey: string;
}

export default class AitiCoreClientFoxentry {

    settings: SettingsOptions;
    loadingScript: boolean = false;

    initSettings(settings: SettingsOptions) {
        this.settings = settings;
        return this;
    }

    init(): JQuery.Deferred<void> {
        let _this = this;

        return jQuery.Deferred(function() {
            let deferred = this;

            if (typeof window.Foxentry === 'undefined') {
                if (_this.loadingScript) {
                    deferred.reject();
                    return;
                }

                _this.loadingScript = true;

                AitiCore.getUtils().loadScript('https://cdn.foxentry.cz/lib', function() {
                    return typeof window.FoxentryBase === 'undefined' ? '/js/foxentry/lib.js' : null;
                }).done(function() {
                    window.onFoxentryProjectLoad = function() {
                        setTimeout(function() {
                            deferred.resolve();
                        });
                    };
                    window.Foxentry = new window.FoxentryBase(_this.settings['clientKey']);
                }).fail(function() {
                    deferred.reject();
                });

                return;
            }

            if (!window.Foxentry.isReady()) {
                setTimeout(function() {
                    if (window.Foxentry.isReady()) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                });

                return;
            }

            deferred.resolve();
        });
    }

    validateEmail(value: string): JQuery.Deferred<FoxentryEmailValidationResult> {
        let _this = this;

        value = value || '';

        return jQuery.Deferred(function() {
            let deferred = this;

            _this.init().done(function() {
                window.Foxentry.api.email.validate(value, 'extended', function(result) {
                    deferred.resolve(new FoxentryEmailValidationResult(result));
                });
            }).fail(function() {
                deferred.reject();
            });
        });
    }
}

export class FoxentryEmailValidationResult {

    result: object;

    constructor(result) {
        this.result = result;
    }

    isSuccess() {
        return !!(this.result && this.result['success']);
    }

    isValid() {
        return !!(this.isSuccess() && this.result['data']['valid']);
    }

    getErrorCode() {
        return this.isSuccess() ? this.result['data']['errorCode'] : null;
    }

    getHintValue() {
        return this.isSuccess() && this.result['data']['hint'] ? this.result['data']['hint']['value'] : null;
    }
}

declare global {
    interface Window {
        Foxentry: any;
        FoxentryBase: any;
        onFoxentryProjectLoad: Function;
    }
}
